exports = module.exports = require("../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ace_line_group {\n  text-align: left;\n}\n.json-editor-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n}\n.json-editor-container .tree-mode {\n  width: 50%;\n}\n.json-editor-container .code-mode {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n}\n.jsoneditor-btns{\n  text-align: center;\n  margin-top:10px;\n}\n.jsoneditor-vue .jsoneditor-outer{\n  min-height:150px;\n}\n.jsoneditor-vue div.jsoneditor-tree{\n  min-height: 350px;\n}\n.json-save-btn{\n  background-color: #20A0FF;\n  border: none;\n  color:#fff;\n  padding:5px 10px;\n  border-radius: 5px;\n}\n.json-save-btn:focus{\n  outline: none;\n}\n.json-save-btn[disabled]{\n  background-color: #1D8CE0;\n}\ncode {\n  background-color: #f5f5f5;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-64d80511","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./~/vue-json-editor/vue-json-editor.vue
// module id = 859
// module chunks = 1